// src/services/apiClient.js
import axios from 'axios';

// Configuración base de la API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

// Crear instancia de axios
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autenticación
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken') || localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Manejar errores globalmente
    if (error.response?.status === 401) {
      // Token expirado o inválido
      localStorage.removeItem('authToken');
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Detectar si el usuario está en el portal de clientes
      const currentPath = window.location.pathname;
      const isPortalRoute = currentPath.startsWith('/portal');

      // Redirigir según el contexto
      if (isPortalRoute) {
        window.location.href = '/portal';
      } else {
        window.location.href = '/login';
      }
    } else if (error.response?.status === 403) {
      console.error('No tienes permisos para realizar esta acción');
    } else if (error.response?.status >= 500) {
      console.error('Error del servidor. Por favor, intenta más tarde.');
    }

    return Promise.reject(error);
  }
);

export default apiClient;
